export default __webpack_public_path__ + "static/media/H4002.1.52b71244.mp3";